import { environment } from "../config";

export function isDev() {
  return environment === "Development";
}

export function isLocalhost() {
  return environment === "Development";
}

export function isProduction() {
  return environment === "Production";
}

export const showMockFeature = isDev() || isLocalhost();
export const hideOnProduction = !isProduction();
